.illustration-container {
    min-width: 64px;
    min-height: 64px;
}
